import { ajaxInstance} from "../utils/axios";


export default function useClient(){
    let getAllClientsUrl = `api/clients/list`
    let sendClientFileUrl = `/api/clients/store`


    const getAllClients = (currentPage, size=null, search=null) => {
        let params = {
            ...(currentPage !== null && {page: currentPage}),
            ...(size !== null && {size: size}),
            ...(search !== null && {search: search})
        }
        return new Promise((resolve, reject) => {
            ajaxInstance.get(getAllClientsUrl, { params: params
            }).then((response) => {
                const data = response.data
                console.log('Get clientHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in get clientHook', errors)
                    reject()
                }else{
                    console.log('Error in get clientHook', error)
                    reject()
                }
            })
        })
    }
    const uploadClientsFile = (file) => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', file[0])
            ajaxInstance.post(
                sendClientFileUrl,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    timeout: 20000
                }
            ).then((response) => {
                const data = response.data
                console.log('Post clientHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in post clientHook', errors)
                    reject(errors)
                }else{
                    console.log('Error in post clientHook', error)
                    reject('Ocurrió un problema')
                }
            })
        })
    }

    return {
        getAllClients,
        uploadClientsFile
    }

}